import React, { useEffect, useState } from "react"; // eslint-disable-line
/* Components */
import Button from "../components/button/button";
import { useMediaQuery } from "react-responsive"; // eslint-disable-line
import { useMixPanel } from "../hooks/useMixPanel"; // eslint-disable-line
import { useTranslation } from "react-i18next"; // eslint-disable-line
import useGlobalStore from "../store/useGlobalStore";
import CardList from "../components/card/card-list";
import FormCourseProfile from "../components/form/formCourseProfile";

const CourseProfile = () => {
  const { t } = useTranslation();
  const { 
    createCourseProfileH,
    setCreateCourseProfileH,
  } = useGlobalStore();

  const toggleCreateCourseProfileH = () => { 
    setCreateCourseProfileH(!createCourseProfileH);
  }

  const coursesList = [];

  return (
    <>
      <div className="wrapper-home relative">
        {/* PopUp Creación de perfil de curso */}
        { createCourseProfileH && 
          <div className={`history absolute z-40 w-full h-full rounded-4 bg-DarkBlue-600 overflow-hidden shadow-dark-xl`}>
            <div className="sticky top-0 flex flex-row justify-between items-center p-4 bg-DarkBlue-700">
              <h6 className="blue-text sidebar-title">Perfil de curso</h6>
              <Button
                label="Cerrar"
                variant="primary"
                onClick={toggleCreateCourseProfileH}
                customClassName="py-2 h-6"
              />
            </div>
            <div className="w-full max-h-[90%] h-full relative p-4 overflow-y-auto pb-4">
              <FormCourseProfile />
            </div>
          </div>
        }
        <div className={`wrapper_chat-home`}>
          <div className={`chat-content-home`}>
            <div className="chat-content_wrapper">
              {coursesList.length ? <CardList cardsData={coursesList} /> : <div className='text-center mt-4 text-Grey-500 font-bold text-lg' >{t("home_super_poder_cargando")}</div>}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default CourseProfile;